import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex',
    text: 'heading-m flex min-w-40 items-center justify-center uppercase',
    button: 'min-w-40'
  },
  variants: {
    bgColor: {
      base: {
        text: 'bg-color-base text-black'
      },
      disabled: {
        text: 'bg-color-disabled text-black'
      }
    }
  }
});
